import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../../services/tools/helpers.service';
import { CarburacionesUnidadesService } from '../../../../../services/creditos/carburaciones-unidades.service';

@Component({
  selector: 'carburacion-unidad',
  templateUrl: './carburacion-unidad.component.html',
  styleUrls: ['./carburacion-unidad.component.scss']
})
export class CarburacionUnidadComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @Input() public isCompleted : boolean = false;
    @Input() public idTipos_Creditos : number = null;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
    //Cliente form
    public unidad : any = {};
    public errors : any = {};
    private isInitialized : boolean = false;

    constructor(
      private helperService: HelpersService,
      private unidadesService : CarburacionesUnidadesService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getUnidad(this.idCreditos);
        this.isInitialized = true;
      }
    }
    
    private getUnidad(idCreditos : number){
      //TODO: Manejar cuando el id no retorna un aval valido
      this.unidadesService.get(idCreditos).subscribe(
        (response)=>
        {
          const unidades = response.json().content;
          if(unidades.length > 0){
              this.unidad = unidades[0];
          }          
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public save(){
      this.errors = {};

      let unidad = this.unidad;
      //Asigna el tipo de Crédito. Ya que hay campos que no se requieren para todos los créditos
      this.errors = this.unidadesService.validate(unidad);

      if (Object.entries(this.errors).length > 0) {
      return false;
      }

      if(unidad.id && unidad.id > 0){
          //Actualiza la información
          this.update(unidad);
      }else{
          //Crear por primera vez el registro referente a la unidad
          this.create(unidad);
      }      
    }

    private create(unidad : any){
      unidad.idCreditos = this.idCreditos;
      
      this.unidadesService.save(unidad).subscribe(
          (response)=>
          {
            this.unidad.id = response.json().content.id;
            this.helperService.notification('Unidad actualizada', 'Se ha actualizado exitosamente la información de la unidad ', 'success');
            this.onDataUpdated.emit();
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }

    private update(unidad : any){      
      this.unidadesService.update(unidad).subscribe(
          (response)=>
          {
            this.helperService.notification('Unidad actualizada', 'Se ha actualizado exitosamente la información de la unidad ', 'success');
            this.onDataUpdated.emit();
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
      );
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/crediga-carburacion/detalles/components/unidad/carburacion-unidad.component.ts